// frontend/modules/customer-notification/hooks/useSmsBalance.ts
import { useCallback, useEffect } from 'react';
import { showErrorNotification } from '@/components/common/utils/notify';
import { useTheme } from '@/components/common/ThemeProvider';

// Import the SMS client controller functions (assuming these are available)
import { useGetSmsBalance } from '@/shared/api/client/sms-client-controller';

export const useSmsBalance = () => {
    const { dark } = useTheme();

    // API query for SMS balance
    const {
        data: balanceData,
        isLoading,
        refetch,
        error
    } = useGetSmsBalance();

    // Handle error state
    useEffect(() => {
        if (error) {
            console.error('Error loading SMS balance:', error);
            showErrorNotification('Error', 'Failed to load SMS balance', dark);
        }
    }, [error, dark]);

    // Get the actual balance value from the response
    const smsBalance = balanceData?.remainingBalance || null;
    const totalAllocation = balanceData?.remainingBalance || 0; // Default if not provided

    // Reload SMS balance
    const refreshSmsBalance = useCallback(() => {
        refetch();
    }, [refetch]);

    return {
        smsBalance,
        totalAllocation,
        isLoading,
        error,
        refreshSmsBalance
    };
};